//* global window */
import { h } from './element';
import Suggest from './suggest';
import Datepicker from './datepicker';
// XSTORAGE:テキストエリアモード対応
import { cssPrefix, TEXT_AREA_HEIGHT, TEXT_AREA_HEIGHT_VALUE } from '../config';
// import { mouseMoveUp } from '../event';

// XSTORAGE:テキストエリアモード対応、テキストエリアのクリア機能
function resetTextareaSize() {
  const { inputText, validator } = this;
  if (!/^\s*$/.test(inputText)) {
    const {
      textlineEl, textEl, areaOffset, clearButtonEl,
    } = this;
    const txts = inputText.replaceAll('\r\n','\n').replaceAll('\r','\n').split('\n');
    const maxTxtSize = Math.max(...txts.map(it => it.length));
    const tlOffset = textlineEl.offset();
    const fontWidth = tlOffset.width / inputText.length;
    const tlineWidth = (maxTxtSize + 1) * fontWidth + 5;
    const maxWidth = this.viewFn().width - areaOffset.left - fontWidth;
    let h1 = txts.length;
    // XSTORAGE:textareaの場合、スクロールバーを出すので幅は広げない
    if (tlineWidth > areaOffset.width && (!validator || validator.type != 'textarea')) {
      let twidth = tlineWidth;
      if (tlineWidth > maxWidth) {
        twidth = maxWidth;
        h1 += parseInt(tlineWidth / maxWidth, 10);
        h1 += (tlineWidth % maxWidth) > 0 ? 1 : 0;
      }
      textEl.css('width', `${twidth}px`);
    }
    h1 *= this.rowHeight;

    // XSTORAGE:テキストエリアモード対応、テキストエリアのクリア機能
    if (validator && validator.type == 'textarea') {
      textEl.css('height', TEXT_AREA_HEIGHT);
      textEl.css('overflow', 'auto');
      clearButtonEl.css('display', 'block');
    } else if (h1 > areaOffset.height) {
      textEl.css('height', `${h1}px`);
      textEl.css('overflow', 'hidden');
      textEl.css('white-space', 'nowrap');
      clearButtonEl.css('display', 'none');
    } else {
      textEl.css('height', `${areaOffset.height}px`);
      textEl.css('overflow', 'hidden');
      textEl.css('white-space', 'nowrap');
      clearButtonEl.css('display', 'none');
    }
  } else {
    // XSTORAGE:テキストエリアモード対応
    if (validator && validator.type == 'textarea') {
      this.textEl.css('height', TEXT_AREA_HEIGHT);
      this.textEl.css('overflow', 'auto');
      this.clearButtonEl.css('display', 'block');
    } else {
      this.textEl.css('height', `${this.areaOffset.height}px`);
      this.textEl.css('overflow', 'hidden');
      this.textEl.css('white-space', 'nowrap');
      this.clearButtonEl.css('display', 'none');
    }
  }
}

function insertText({ target }, itxt) {
  const { value, selectionEnd } = target;
  const ntxt = `${value.slice(0, selectionEnd)}${itxt}${value.slice(selectionEnd)}`;
  target.value = ntxt;
  target.setSelectionRange(selectionEnd + 1, selectionEnd + 1);

  this.inputText = ntxt;
  this.textlineEl.html(ntxt);
  resetTextareaSize.call(this);
}

function keydownEventHandler(evt) {
  const { keyCode, altKey } = evt;
  if (keyCode !== 13 && keyCode !== 9) evt.stopPropagation();
  if (keyCode === 13 && altKey) {
    insertText.call(this, evt, '\n');
    evt.stopPropagation();
  }
  if (keyCode === 13 && !altKey) evt.preventDefault();
}

function inputEventHandler(evt) {
  const v = evt.target.value;
  // console.log(evt, 'v:', v);
  const { suggest, textlineEl, validator } = this;
  const { cell } = this;
  if (cell !== null) {
    if (('editable' in cell && cell.editable === true) || (cell.editable === undefined)) {
      this.inputText = v;
      if (validator) {
        // XSTORAGE:ダイアログモード対応
        // XSTORAGE:マルチセレクト対応
        if (validator.type === 'list') {
          suggest.search(v, null);
        } else if (validator.type === 'multiselect') {
          suggest.search(v, this.inputText, validator.descriptionFormat);
        } else if (validator.type === 'dialog') {
          suggest.search(v, null);
        } else {
          suggest.hide();
        }
      } else {
        const start = v.lastIndexOf('=');
        if (start !== -1) {
          suggest.search(v.substring(start + 1), null);
        } else {
          suggest.hide();
        }
      }
      textlineEl.html(v);
      resetTextareaSize.call(this);
      this.change('input', v);
    } else {
      evt.target.value = cell.text || '';
    }
  } else {
    this.inputText = v;
    if (validator) {
      // XSTORAGE:ダイアログモード対応
      // XSTORAGE:マルチセレクト対応
      if (validator.type === 'list') {
        suggest.search(v, null);
      } else if (validator.type === 'multiselect') {
        suggest.search(v, this.inputText, validator.descriptionFormat);
      } else if (validator.type === 'dialog') {
        suggest.search(v, null);
      } else {
        suggest.hide();
      }
    } else {
      const start = v.lastIndexOf('=');
      if (start !== -1) {
        suggest.search(v.substring(start + 1), null);
      } else {
        suggest.hide();
      }
    }
    textlineEl.html(v);
    resetTextareaSize.call(this);
    this.change('input', v);
  }
}

function setTextareaRange(position) {
  const { el } = this.textEl;
  setTimeout(() => {
    el.focus();
    el.setSelectionRange(position, position);
  }, 0);
}

function setText(text, position) {
  const { textEl, textlineEl } = this;
  // firefox bug
  textEl.el.blur();

  textEl.val(text);
  textlineEl.html(text);
  setTextareaRange.call(this, position);
}

function suggestItemClick(it) {
  const { inputText, validator, sheet } = this;
  let position = 0;
  let dialogMode = false;
  let currentValue = this.inputText;
  if (validator && validator.type === 'list') {
    this.inputText = it;
    position = this.inputText.length;
  } else if (validator && validator.type === 'multiselect') {

    // XSTORAGE:マルチセレクト対応
    // XSTORAGE:マルチセレクトの補足対応
    var reg = null;
    if (validator.descriptionFormat != null && validator.descriptionFormat.trim() != '') {
      reg = new RegExp(validator.descriptionFormat, "ig");
    }
    let currentValues = getCurrentValues(currentValue, reg);

    let exists = false;
    currentValues.forEach(val => {
      if (reg != null && val.toLowerCase().replaceAll(reg, '').trim() == it.toLowerCase().trim()) 
      {
        exists = true;
        return;
      }
      else if (reg == null && val.toLowerCase().trim() == it.toLowerCase().trim()) 
      {
        exists = true;
        return;
      }
    });

    if (exists) {

      let newValues = [];
      currentValues.forEach(val => {
        if (reg != null && val.toLowerCase().replaceAll(reg, '').trim() != it.toLowerCase().trim()) {
          newValues.push(val.trim());
        }
        else if (reg == null && val.toLowerCase().trim() != it.toLowerCase().trim()) 
        {
          newValues.push(val.trim());
        }
      });

      if (newValues.length == 0) {
        this.inputText = "";
      } else {
        this.inputText = newValues.join(", ");
      }

    } else {

      if(typeof currentValue==="undefined" || currentValue === null || currentValue === "") {
        this.inputText = it.trim();
      } else {
        let newValues = [];
        currentValues.forEach(val => {
          newValues.push(val.trim());
        });
        newValues.push(it.trim());
        this.inputText = newValues.join(", ");
      }

    }
    position = this.inputText.length;
  } else if (validator && validator.type === 'dialog') {
    // XSTORAGE:ダイアログモード対応
    dialogMode = true;
  } else {
    const start = inputText.lastIndexOf('=');
    const sit = inputText.substring(0, start + 1);
    let eit = inputText.substring(start + 1);
    if (eit.indexOf(')') !== -1) {
      eit = eit.substring(eit.indexOf(')'));
    } else {
      eit = '';
    }
    this.inputText = `${sit + it.key}(`;
    // console.log('inputText:', this.inputText);
    position = this.inputText.length;
    this.inputText += `)${eit}`;
  }

  if (dialogMode) {
    if (it === this.openDialogCaption) {
      sheet.trigger('open-dialog', this, sheet.selector.range.sri, sheet.selector.range.sci);
    }
  } else {
    setText.call(this, this.inputText, position);
    // XSTORAGE:マルチセレクト対応(セレクトの結果、空にする場合はきちんと空にする)
    this.clear(true);
  }
}

function resetSuggestItems() {
  this.suggest.setItems(this.formulas);
}

// XSTORAGE:補足を加味して分解した既存入力値の配列を返す
function getCurrentValues(currentValue, reg) {
  var currentValues = currentValue.split(',');
  const DUMMY_DESCRIPTION = '$_DESC_$';
  var matched;
  if (reg != null) {
    currentValues = currentValue.replaceAll(reg, DUMMY_DESCRIPTION).split(',');
    matched = currentValue.match(reg);
  }

  var newValues = [];
  var matchedIndex = 0;
  currentValues.forEach((cv) => {
    if (cv.includes(DUMMY_DESCRIPTION)) {
      newValues.push(cv.replace(DUMMY_DESCRIPTION, matched[matchedIndex++]));
    } else {
      newValues.push(cv);
    }
  });
  return newValues;
}

// XSTORAGE:フォーマットを直した
function dateFormat(d, shortDateFormat) {
  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let date = d.getDate();
  if (month < 10) month = `0${month}`;
  if (date < 10) date = `0${date}`;
  return shortDateFormat.toLowerCase().replace('yyyy', year).replace('mm', month).replace('m', month).replace('dd', date).replace('d', date);
  //return `${d.getFullYear()}-${month}-${date}`;
}

// XSTORAGE:コンストラクターに shortDateFormat を追加 + datepickerのsetTextにも追加
// XSTORAGE:コンストラクターに openDialogCaption を追加
// XSTORAGE:コンストラクターに sheet を追加（イベント発行するため）
export default class Editor {
  constructor(formulas, viewFn, rowHeight, shortDateFormat, openDialogCaption, sheet) {
    this.viewFn = viewFn;
    this.rowHeight = rowHeight;
    this.formulas = formulas;
    this.shortDateFormat = shortDateFormat;
    this.openDialogCaption = openDialogCaption;
    this.sheet = sheet;
    this.suggest = new Suggest(formulas, (it) => {
      suggestItemClick.call(this, it);
    }, openDialogCaption);
    this.datepicker = new Datepicker();
    this.datepicker.change((d) => {
      // console.log('d:', d);
      this.setText(dateFormat(d, this.shortDateFormat));
      this.clear();
    });
    this.areaEl = h('div', `${cssPrefix}-editor-area`)
      .children(
        this.textEl = h('textarea', '')
          .on('input', evt => inputEventHandler.call(this, evt))
          .on('paste.stop', () => {})
          .on('keydown', evt => keydownEventHandler.call(this, evt)),
        // XSTORAGE:テキストエリアのクリア機能
        this.clearButtonEl = h('button', `${cssPrefix}-clear-button`)
          .css('width', '100%')
          .css('height', '20px')
          .css('border', 'solid 1px lightsteelblue')
          .html('Clear')
          .on('click', () => this.clearButtonClicked()),
        this.textlineEl = h('div', 'textline'),
        this.suggest.el,
        this.datepicker.el,
      )
      .on('mousemove.stop', () => {})
      .on('mousedown.stop', () => {});
    this.el = h('div', `${cssPrefix}-editor`)
      .child(this.areaEl).hide();
    this.suggest.bindInputEvents(this.textEl);

    this.areaOffset = null;
    this.freeze = { w: 0, h: 0 };
    this.cell = null;
    this.inputText = '';
    this.change = () => {};
    // XSTORAGE:エディタの表示中はシステム標準のコピーに任せる
    this.isEditing = false;
  }

  setFreezeLengths(width, height) {
    this.freeze.w = width;
    this.freeze.h = height;
  }

  // XSTORAGE:クリアボタンクリック時のイベント起動
  clearButtonClicked() {
    this.inputText = "";
    this.clear(true);
    this.sheet.trigger('clearbutton-clicked', this, this.sheet.selector.range.sri, this.sheet.selector.range.sci);
  }

 
  // XSTORAGE:マルチセレクト対応(セレクトの結果、きちんと空にするケースがあるため)
  clear(force = false) {
    if (this.inputText !== '' || force === true) {
      this.change('finished', this.inputText);
    }
    this.cell = null;
    this.areaOffset = null;
    this.inputText = '';
    this.el.hide();
    this.textEl.val('');
    this.textlineEl.html('');
    resetSuggestItems.call(this);
    this.datepicker.hide();
    // XSTORAGE:エディタの表示中はシステム標準のコピーに任せる
    this.isEditing = false;
  }

  setOffset(offset, suggestPosition = 'top') {
    const {
      textEl, areaEl, suggest, freeze, el,
    } = this;
    if (offset) {
      this.areaOffset = offset;
      console.log("setOffset...offset.top, offset.height", offset.top, offset.height);
      const {
        left, top, width, height, l, t,
      } = offset;
      // console.log('left:', left, ',top:', top, ', freeze:', freeze);
      const elOffset = { left: 0, top: 0 };
      // top left
      if (freeze.w > l && freeze.h > t) {
        //
      } else if (freeze.w <= l && freeze.h <= t) {
        elOffset.left = freeze.w;
        elOffset.top = freeze.h;
      } else if (freeze.w > l) {
        elOffset.top = freeze.h;
      } else if (freeze.h > t) {
        elOffset.left = freeze.w;
      }
      el.offset(elOffset);
      console.log("setOffset...elOffset.top", elOffset.top);
      areaEl.offset({ left: left - elOffset.left - 0.8, top: top - elOffset.top - 0.8 });
      console.log("setOffset...top, top - elOffset.top", top, top - elOffset.top);
      // XSTORAGE:テキストエリアモード対応
      if (textEl.el.offsetHeight != TEXT_AREA_HEIGHT_VALUE) {
        textEl.offset({ width: width - 9 + 0.8, height: height - 3 + 0.8 });
      }
      const sOffset = { left: 0 };
      sOffset[suggestPosition] = height;
      suggest.setOffset(sOffset);
      suggest.hide();
    }
  }

  setCell(cell, validator) {
    if (cell && cell.editable === false) return;

    // console.log('::', validator);
    const { el, datepicker, suggest } = this;

    // XSTORAGE:テキストエリアモード対応（バリデータのセットタイミングが遅すぎるので早めに変更）
    this.validator = validator;

    el.show();
    
    // XSTORAGE:エディタの表示中はシステム標準のコピーに任せる
    this.isEditing = true;

    this.cell = cell;
    const text = (cell && cell.text) || '';
    this.setText(text);

    if (validator) {
      const { type } = validator;
      if (type === 'date') {
        datepicker.show();
        if (!/^\s*$/.test(text)) {
          datepicker.setValue(text, this.shortDateFormat, dateFormat);
        }
      }
      // XSTORAGE:ダイアログモード対応
      // XSTORAGE:マルチセレクト対応
      if (type === 'dialog') {
        suggest.setItems(this.openDialogCaption.split('\\'));
        suggest.search('', null);
      } else if (type === 'list') {
        suggest.setItems(validator.values());
        suggest.search('', null);
      } else if (type === 'multiselect') {
        suggest.setItems(validator.values());
        suggest.search('', this.inputText, validator.descriptionFormat);
      }
    }
  }

  setText(text) {
    this.inputText = text;
    // console.log('text>>:', text);
    setText.call(this, text, text.length);
    resetTextareaSize.call(this);
  }
}
